import { useMemo } from 'react';
import { TFunction } from 'i18next';

import {
  BoardMineralization,
  BoardSoil,
  BoardStatus,
} from 'features/Croptimizer/types';
import { getEfficiencyFormula } from 'features/Croptimizer/utils/calcHelperBoard';
import { numericValues } from 'utils/helpers';

interface Props {
  getY1CurrentProfit: string;
  mineralizationValues: BoardMineralization | null;
  boardStatusValues: BoardStatus | null;
  boardSoilValues: BoardSoil | null;
  optimumValue: number;
  t: TFunction;
}

const Y2CurrentProfitFirst = ({
  getY1CurrentProfit,
  boardStatusValues,
  mineralizationValues,
  boardSoilValues,
  optimumValue,
  t,
}: Props) => {
  const result = useMemo(() => {
    if (
      getY1CurrentProfit &&
      boardStatusValues &&
      mineralizationValues &&
      boardSoilValues
    ) {
      const getSec = (
        ((Math.tan((Number(getY1CurrentProfit) - 5.8) / 1.45) * 54 + 70) /
          100 /
          0.05) *
        5
      ).toFixed(2);

      const ag38 = getEfficiencyFormula(
        Number(mineralizationValues?.month),
        Number(boardStatusValues?.currentPh),
        Number(numericValues(boardStatusValues?.currentSec)),
        // Number(boardSoilValues?.selected),
        optimumValue,
        Number(numericValues(mineralizationValues?.soilTillage)),
      );
      const ah38 = getEfficiencyFormula(
        24,
        Number(getY1CurrentProfit),
        Number(getSec),
        // Number(boardSoilValues?.selected),
        optimumValue,
        Number(numericValues(mineralizationValues?.soilTillage)),
      );
      const ag31 = ag38;
      const ah31 = ah38 < ag31 ? ag31 : ah38;
      const ai78 = ah31 / 100;
      const ah78 = ag31 / 100;
      const ai71 = ai78 - ah78;
      const ai64 = ai71 / Number(boardSoilValues?.split);
      const ah71 = ah78;
      const ah64 = ah71 / Number(boardSoilValues?.split);
      const dose = Number(numericValues(boardSoilValues?.dose)) / 100;
      const ai65 = (ah78 + ai71) / Number(boardSoilValues?.split);

      if (mineralizationValues?.cap === t('no')) {
        if (boardSoilValues?.split === '1') {
          return (
            Number(getY1CurrentProfit) -
            Number(mineralizationValues?.annualDecrease)
          ).toFixed(2);
        } else {
          const rightside =
            Number(getY1CurrentProfit) -
            Number(mineralizationValues?.annualDecrease);
          const centerPh =
            Number(boardStatusValues?.targetPh) -
            Number(boardStatusValues?.currentPh);
          const centerDose = dose / Number(boardSoilValues?.split);
          const getCenter = centerPh * centerDose;

          // return (rightside + getCenter).toFixed(2);
          return (rightside + getCenter).toFixed(3);
        }
      } else {
        if (boardSoilValues?.split === '1') {
          const first = Number(boardStatusValues?.currentPh);
          const second =
            Number(boardStatusValues?.targetPh) -
            Number(boardStatusValues?.currentPh);
          const third = ah64 + ai64;
          const fourth = Number(mineralizationValues?.annualDecrease) * 2;

          return (first + second * third - fourth).toFixed(2);
        }

        const first = Number(boardStatusValues?.currentPh);
        const second =
          Number(boardStatusValues?.targetPh) -
          Number(boardStatusValues?.currentPh);
        const third = ah64 + ai65;
        const fourth = Number(mineralizationValues?.annualDecrease) * 2;

        return (first + second * third - fourth).toFixed(2);
      }
    }
  }, [
    getY1CurrentProfit,
    boardStatusValues,
    mineralizationValues,
    boardSoilValues,
    boardSoilValues?.split,
  ]);

  return { result };
};

export default Y2CurrentProfitFirst;
